import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ShIconComponent } from '@gbr-monorepo/gbr-shui';

@Component({
    selector: 'app-screen-too-small',
    imports: [ShIconComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './screen-too-small.component.html'
})
export class ScreenTooSmallComponent {
    public readonly titleText = input<string>();
    public readonly descriptionText = input<string>();
}
